import { render, staticRenderFns } from "./DeliveryTypesEligibility.vue?vue&type=template&id=af0cfdfa"
import script from "./DeliveryTypesEligibility.vue?vue&type=script&lang=js"
export * from "./DeliveryTypesEligibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports